import { StorageMap } from '@ngx-pwa/local-storage';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoyaltyService } from 'src/app/modules/retailer/services/loyalty.service';

@Component({
  selector: 'app-loyalty-report',
  templateUrl: './loyalty-report.component.html',
  styleUrls: ['./loyalty-report.component.scss']
})
export class LoyaltyReportComponent implements OnInit {

  public loginData: any;

  public customers: any = [];
  public customersPageSize: number = 1;
  public customersPage: number = 1;
  public customersCount: number = 0;
  public customersSortField: string = 'name'; // Default sort by start date
  public customersSortType: string = 'asc'; // Default sort ascending order
  public customersLoading: boolean = false;

  public reportFilter: any;

  public pageSize: any = [ {id: 1, value: 10}, {id: 2, value: 25}, {id: 3, value: 50}, {id: 4, value: 100}];

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _loyaltyService: LoyaltyService
  ) {}

  ngOnInit(): void {
    this.getStorageData();
  }

  // Go to loyalty settings
  onSettingsClick(){
    this._router.navigate(['/retailer/loyalty/settings'], {});
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    // Set defaults
    this.customersPageSize = this.pageSize[0].value;
    this.customersPage = 1;
    //this.getCustomersReport(); // THIS IS CALLED FROM onfilterChange()
  }

  // Get customers report
  getCustomersReport() {
    /*if (this.reportFilter) {
      this.customers = [];
      this.customersCount = 0;
      this.customersLoading = true;

      let getLoyaltyCustomerListBody = {
        retailer_id: this.loginData.user_details.provider_id,
        store_id: this.reportFilter.store,
        page: this.customersPage,
        page_size: this.customersPageSize,
        sort_field: this.customersSortField,
        sort_type: this.customersSortType
      };

      this._reportsService.getLoyaltyCustomerList(this.loginData.token, getLoyaltyCustomerListBody).subscribe(async getCouponsReportResponse => {
        this.couponsLoading = false;

        if (getCouponsReportResponse.status === true) { // Success
          this.coupons = getCouponsReportResponse.coupons;
          this.couponsCount = getCouponsReportResponse.total_count;

          // Get coupons sales data
          this.getCouponsSalesReport();
        } else {
          this._utilService.showToast(getCouponsReportResponse.message, '', 'error', {});
        }
      }, error => { // Error from getCouponsReport
        this.couponsLoading = false;
      });
    }*/
  }

  // Change sorting
  changeSorting(field: string) {
    if (this.customers.length > 0) {
      if (this.customersSortField == field) { // Same field - Change sort type
        if (this.customersSortType == 'asc') {
          this.customersSortType = 'desc';
        } else {
          this.customersSortType = 'asc';
        }
      } else { // Different field - Set sort descending
        this.customersSortType = 'desc';
      }

      this.customersSortField = field;

      this.customersPage = 1;
      this.getCustomersReport();
    }
  }

  // Page size change
  onPageSizeChange(event: any) {
    this.customersPage = 1;
    this.getCustomersReport();
  }

  // Page change
  onCustomersPageChange(event: any) {
    this.customersPage = event;
    this.getCustomersReport();
  }

  // On filter change
  async onfilterChange(event: any) {
    this.reportFilter = event;

    this.customersPage = 1;
    this.getCustomersReport();
  }

}
